import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
import Quiz from "../quiz_template/Quiz";
import { usertype_change } from "./IntroQuiz.Slice";
// import {
//   getQuizThunk,
//   createIntroQuizThunk,
//   updateCommonQuizTopicThunk,
//   deleteCommonQuizTopicThunk,
// } from "./CommonQuizTopic.Thunk";
import {
  getQuizThunk,
  createIntroQuizThunk,
  updateCommonQuizTopicThunk,
  deleteQuizThunk,
} from "./IntroQuiz.Thunk";
import { deleteFileFromDB } from "../../components/Azure";

const TeacherCategoryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, topicId, topicName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(topicId);
    setSelectedSkillsetName(topicName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/commonmonthlyquiz");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];
  // ------------ dropdowns on change ----------------
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };

  const data = useSelector((state) => state.CommonQuizTopicSlice.topic);

  // ------------ Load data & skill ----------------

  const topicId = useSelector((state) => state.CommonQuizTopicSlice.topicId);
  //console.log("topicId----------------------->", topicId);

  const topicName = useSelector(
    (state) => state.CommonQuizTopicSlice.topicName
  );
  // const [validityType, setValidityType] = useState("");
  // //console.log("validityType-->", validityType);

  const usertype = useSelector((state) => state.CommonQuizTopicSlice.usertype);

  useEffect(() => {
    const load_data = () => {
      const params = { usertype };
      dispatch(getQuizThunk(params));
    };
    load_data();
  }, [dispatch, usertype]);

  // -----------------------------------------------

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  // ----------- create, update delete button click ----------
  const [isLoading, setIsLoading] = useState(false);

  const [updateData, setUpdateData] = useState({
    // _id: "",
    questionId: new Date().getTime(),
    topicId: topicId,
    topicName: "",
    validity: "",
    validityType: "",
    // duration: "",
    usertype: usertype,
    language: "od",
    module: "teacher",
  });
  //console.log("updateData-->", updateData);

  const delete_content_button_click = (questionId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete all questions? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteQuizThunk(questionId)).then(() => {
            const params = { usertype };
            dispatch(getQuizThunk(params));
            toast.success("Successfully Deleted");
          });
        }
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const delete_quiz_button_click = (eachskill) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          deleteFileFromDB(eachskill.questionMedia);
          const qz = data.filter(
            (item) => item.questionId != eachskill.questionId
          );
          const data6 = {
            usertype,
            quizData: qz,
          };
          //console.log("data delete--->", data6);
          dispatch(createIntroQuizThunk(data6)).then((res) => {
            const params = { usertype };
            dispatch(getQuizThunk(params));
          });
        }
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const [action, setAction] = useState("");
  const [params, setParams] = useState(null);
  const [changeQuestion, setChangeQuestion] = useState("");
  const handleChangeQuestion = (event) => {
    setChangeQuestion(event.target.value);
  };

  const [showQuizDialog, setShowQuizDialog] = useState(false);
  const quiz_on_close = () => setShowQuizDialog(false);

  const quiz_on_open = (action, quizObject) => {
    const param = { action, quizObject };
    setAction(action);
    setParams(param);
    if (
      usertype === undefined ||
      usertype === null ||
      usertype.trim().length <= 0
    )
      alert("Usertype is Missing");
    // else if (topicId === undefined || topicId === null || topicId.trim().length <= 0) alert("Topic is Missing");
    else setShowQuizDialog(true);
  };

  const quiz_on_save = (quizdata) => {
    if (action === "save") save_quiz_data(quizdata);
    else if (action === "update") update_quiz_data(quizdata);
  };

  const save_quiz_data = (quizdata) => {
    setIsLoading(true);
    const newdata = {
      usertype: usertype,
      language: "od",
      quizData: [...data, quizdata],
    };

    setShowQuizDialog(false);
    dispatch(createIntroQuizThunk(newdata))
      .then((res) => {
        const params = { usertype };
        dispatch(getQuizThunk(params));
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const update_quiz_data = (quizdata) => {
    const updateDataSet = data.map((item) => {
      if (item.questionId === quizdata.questionId) {
        return {
          ...item,
          ...quizdata,
        };
      }
      return item;
    });
    const data2 = {
      usertype: usertype,
      language: "od",
      // topicId: topicId,
      quizData: updateDataSet,
    };

    setShowQuizDialog(false);
    dispatch(createIntroQuizThunk(data2))
      .then((res) => {
        const params = { usertype };
        dispatch(getQuizThunk(params));
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  return (
    <>
      <div>
        <MuiHeader header="Intro Quiz" />

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <Button onClick={() => quiz_on_open("save")} variant="contained">
            create new Question
            <AddIcon />
          </Button>
        </FormControl>
        {usertype && usertype.length > 0 ? (
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <Button
              onClick={(questionId) => delete_content_button_click(questionId)}
              variant="contained"
            >
              Delete All Question <DeleteIcon />
            </Button>
          </FormControl>
        ) : null}
      </div>

      {/* Show List */}
      <div>
        <br />
        {data && data.length > 0 ? (
          <Paper style={{ width: 1200 }}>
            <Table>
              {data.map((eachskill, index) => (
                <div style={{ maxWidth: "1200px", margin: "auto" }}>
                  <table
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                      maxWidth: "1200px",
                      margin: "auto",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: "600px",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "2px",
                            wordBreak: "break-all",
                          }}
                        >
                          {index + 1}.{eachskill?.question}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="2" style={{ padding: "10px" }}>
                          {eachskill?.instructions && (
                            <div>
                              <b>Instructions-</b> {eachskill?.instructions}
                            </div>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            borderBottom: "1px ",
                            padding: "10px",
                            display: "flex",
                          }}
                        >
                          <div style={{ flex: "1", marginRight: "10px" }}>
                            {eachskill?.optionA && (
                              <div>A: {eachskill.optionA}</div>
                            )}
                          </div>
                          <div style={{ flex: "1" }}>
                            {eachskill?.optionB && (
                              <div>B: {eachskill.optionB}</div>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            borderBottom: "1px ",
                            padding: "10px",
                            display: "flex",
                          }}
                        >
                          <div style={{ flex: "1", marginRight: "10px" }}>
                            {eachskill?.optionC && (
                              <div>C: {eachskill.optionC}</div>
                            )}
                          </div>
                          <div style={{ flex: "1" }}>
                            {eachskill?.optionD && (
                              <div>D: {eachskill.optionD}</div>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" style={{ padding: "10px" }}>
                          {eachskill.correctOption &&
                          eachskill.correctOption.length > 0 ? (
                            <tr>
                              <td>
                                <b>Answer-</b>
                                {eachskill.correctOption}
                              </td>
                            </tr>
                          ) : null}
                          {/* <div>Answer: {eachskill.correctOption}</div> */}
                        </td>
                        <td
                          colSpan="2"
                          style={{
                            textAlign: "right",
                            padding: "5px",
                            // marginTop: "50px",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "blue",
                              color: "white",
                              border: "none",
                              padding: "10px 15px",
                              cursor: "pointer",
                              marginRight: "10px",
                              // content: "varient",
                            }}
                            onClick={() => quiz_on_open("update", eachskill)}
                          >
                            Update
                          </button>{" "}
                          <button
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              padding: "10px 15px",
                              cursor: "pointer",
                            }}
                            onClick={() => delete_quiz_button_click(eachskill)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </Table>
          </Paper>
        ) : null}
      </div>
      {/* Toaster */}
      <ToastContainer />

      <Quiz
        open={showQuizDialog}
        params={params}
        onSubmit={quiz_on_save}
        onClose={quiz_on_close}
      />
    </>
  );
};

export default TeacherCategoryPage;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
